import * as LabelPrimitive from '@radix-ui/react-label';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { LucideIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../lib/utils.ts';

const labelVariants = cva([
    'flex gap-2 items-center',
    'text-sm font-normal leading-none text-neutral-600',
    'peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
]);

type LabelProps = React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
        icon?: LucideIcon;
        required?: boolean;
    };

const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
    ({ className, icon: Icon, children, required = false, ...props }, ref) => (
        <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props}>
            {Icon && (
                <div className="h-8 flex items-center">
                    <Icon className="h-4 w-4 stroke-neutral-600" />
                </div>
            )}
            <span>
                {children}
                {required && <span className="text-red-600 ml-0.5">*</span>}
            </span>
        </LabelPrimitive.Root>
    ),
);
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
